export enum PauseType {
  RBI_ESCALATION = 'RBI_ESCALATION',
  CUSTOMER_GOODWILL = 'CUSTOMER_GOODWILL',
  OTHERS = 'OTHERS'
}

export const PAUSE_REASON_TYPES = [
  {
    value: PauseType.RBI_ESCALATION,
    label: 'RBI Escalation'
  },
  {
    value: PauseType.CUSTOMER_GOODWILL,
    label: 'Customer Goodwill'
  },
  {
    value: PauseType.OTHERS,
    label: 'Others'
  }
];

export interface PauseFormValues {
  pauseDate: string;
  reason: PauseType | null;
  details?: string;
}

export const defaultValues = {
  pauseDate: '',
  reason: null,
  details: ''
};

export enum PAUSE_MESSAGE {
  UPDATE_PAUSE = 'Update pause on this LAN',
  PAUSE_COLLECTIONS = 'Pause collections for this LAN',
  UPDATE_PAUSE_DAYS = 'Update pause days',
  PAUSE_TILL = 'Pause till',
  PAUSE_IMMEDIATE_TODAY = 'The update will be effective from now onwards',
  DATE_ERROR = 'Please enter some other date',
  REASON_UPDATE = 'Reason for update',
  REASON_PAUSE = 'Reason for pausing',
  OTHER_REASONS = 'Other reasons',
  UPDATE_PAUSE_DATE = 'Update pause date',
  PAUSE_COLLECTIONS_EFFORTS = 'Pause collections efforts'
}

export enum PAUSE_ACTION_MESSAGE {
  FAILED_TO_PAUSE = 'Failed to pause collections',
  COLLECTIONS_PAUSED = 'Collections paused successfully'
}
